import { FilterTypeEnum, GridFilter } from '../..';
import { FilterDropdownProps } from '../AntTableInterfaces/Interfaces';

export const SelectFilterName = 'SelectFilter';

// Select Filter Definition
export interface SelectFilterType {
  name: 'SelectFilter';
  version: 1,
  type: FilterTypeEnum;
  search: string;
  selectAll: boolean;
  values: string[];
  displayValues: string[];
  convertBooleanToNumerical: boolean;
}

// Get the Select Filter as a stringified JSON Object
export const getSelectFilterAsString = (
  type: FilterTypeEnum,
  search: string,
  selectAll: boolean,
  values: string[],
  displayValues: string[],
  convertBooleanToNumerical = false,
): string => {
  const selectFilter: SelectFilterType = {
    name: SelectFilterName,
    version: 1,
    type,
    search,
    selectAll,
    values,
    displayValues,
    convertBooleanToNumerical,
  };

  return JSON.stringify(selectFilter);
};

// Get the Select Filter from a stringified JSON Object
export const getSelectFilterAsObject = (selectFilterString: string): SelectFilterType => {
  if (selectFilterString) {
    const selectFilter: SelectFilterType = JSON.parse(selectFilterString);

    // Check if Filter is a Select Filter
    if (selectFilter.name === SelectFilterName) {
      return selectFilter;
    }
  }

  return null;
};

// Get the Select Filter from Filters
export const getSelectFilterFromFilters = (filters: GridFilter[], column: string): SelectFilterType => {
  // Find the correct Filter
  const filter: GridFilter = filters?.filter((filterItem) => filterItem.column === column)[0];

  if (filter) {
    return getSelectFilterAsObject(filter.value);
  }

  return null;
};

interface SelectFilterProps {
  title: string;
  dataIndex: string;
  filterType?: FilterTypeEnum;
  multiple: boolean;
  convertBooleanToNumerical?: boolean;
  props: FilterDropdownProps;
}

export default SelectFilterProps;
